<app-modal
  #deleteVehicleModal
  [modalMessage]="app.text.impact.deleteMessage"
  [modalTitle]="app.text.impact.modalTitle"
  (ok)="deleteVehicle()"
></app-modal>
<app-modal
  #discardChangesModal
  [modalMessage]="app.text.impact.discard"
  [modalTitle]="app.text.impact.modalTitle"
  (ok)="discardChanges()"
  >
</app-modal>
<div class="controls">
  <app-unlock
    [id]="app.vehicleResponsible.id"
    [permission]="!app.vehicleResponsible.isNew"
    >
    @if (
      app.vehicleResponsible.modelHasChanges || app.vehicleResponsible.isNew) {
      @if (!hasInvalidFields() && !saveDisabled) {
        <button
          class="btn"
        (click)="
          app.vehicleResponsible.save(app.vehicleResponsible.model);
          this.app.field.inputSubject.next(true)
        "
          [title]="app.text.impact.save"
          >
          <i class="fa fa-check"></i>
        </button>
      }
      <button
        class="btn"
        [title]="app.text.impact.discard"
        (click)="discardChangesModal.open()"
        >
        <i class="fa fa-times"></i>
      </button>
    }
  </app-unlock>
  @if (app.unlockedId == null) {
    <span>
      @if (!app.vehicleResponsible.isNew) {
        <span>
          <button
            class="btn"
            (click)="deleteVehicleModal.open()"
            [title]="app.text.impact.deleteImpact"
            >
            <i class="fa fa-trash"></i>
          </button>
        </span>
      }
    </span>
  }
</div>
@if (app.customers.expectCurrent !== 'db') {
  <div class="col-md-12 mt-5">
    <app-box
      [box]="app.listId.vehicleResponsible.vehicleResponsible"
      [unlock]="app.vehicleResponsible.id"
      [model]="app.vehicleResponsible.model"
    ></app-box>
  </div>
}
@if (app.customers.expectCurrent === 'db') {
  <div class="descriptionList">
    @if (app.isLocked(app.vehicleResponsible.id)) {
      <div class="col-md-12">
        <legend>
          <div class="heading">{{ app.text.app.data }}</div>
        </legend>
        <div class="field-label col-md-12" id="vehicleResponsible.vehicleName">
          {{ app.field.getLabel("vehicleResponsible.vehicleName") }}
        </div>
        <div class="lineHeight col-md-12" id="vehicleResponsible.vehicleName">
          {{ app.vehicleResponsible.model["vehicleResponsible.vehicleName"] }}
        </div>
        <div class="field-label col-md-12" id="vehicleResponsible.vehicleFleet">
          {{ app.field.getLabel("vehicleResponsible.vehicleFleet") }}
        </div>
        <div class="lineHeight col-md-12" id="vehicleResponsible.vehicleFleet">
          {{ app.vehicleResponsible.model["vehicleResponsible.vehicleFleet"] }}
        </div>
      </div>
    }
    @if (!app.isLocked(app.vehicleResponsible.id)) {
      <div class="col-md-12">
        <app-field
          [model]="app.vehicleResponsible.model"
          [field]="app.fieldId.vehicleResponsible.vehicleName"
          [disabled]="app.isLocked(app.vehicleResponsible.id)"
        ></app-field>
        <app-field
          [model]="app.vehicleResponsible.model"
          [field]="app.fieldId.vehicleResponsible.vehicleFleet"
          [disabled]="app.isLocked(app.vehicleResponsible.id)"
        ></app-field>
      </div>
    }
    <div class="col-md-12 mt-2">
      <div class="tableFixHead">
        <table class="table table-striped">
          <thead>
            <th class="p-1 text-center">
              {{ app.text.responsibles.department }}
            </th>
            <th class="p-1 text-center">BAV</th>
            <th class="p-1 text-center">MaWI</th>
            @if (app.auth.isTeam && app.isLocked(app.impact.id)) {
              <th
                class="p-1"
                >
                {{ app.field.getLabel("impact.actions") }}
              </th>
            }
          </thead>
          @if (!loading) {
            <tbody>
              @for (department of departments; track department) {
                <tr id="{{ department.name }}">
                  <td class="p-1 text-center" id="{{ department.name }}">
                    <span class="department-name">{{ department.name }}</span>
                  </td>
                  <td class="p-1">
                    <div
                      class="col-md-12 text-center"
                      id="{{ department.fields.bav }}"
                      >
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div>
                          {{
                          app.users.getOptionName(app.vehicleResponsible.model[
                          "vehicleResponsible.responsibles"
                          ][department.fields.bav]
                          )}}
                        </div>
                      }
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <div>
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.bav"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="false"
                            [largeInput]="true"
                          ></app-field>
                        </div>
                      }
                      <!-- VERTRETER FIELDS / READ MODE-->
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.bavVertreter }}"
                          >
                          @if (display(department.fields.bavVertreter)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.deputy }}:
                              {{
                              app.users.getOptionName(app.vehicleResponsible.model[
                              "vehicleResponsible.responsibles"
                              ][department.fields.bavVertreter]
                              )}}
                            </small>
                          }
                        </div>
                      }
                      <!-- VERTRETER FIELDS ON CREATE/EDIT MODE -->
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <span
                          id="{{ department.fields.bavVertreter }}"
                          >
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.bavVertreter"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                      <!-- SECOND VERTRETER FIELDS / READ MODE-->
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.bavVertreter2 }}"
                          >
                          @if (display(department.fields.bavVertreter2)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.secondDeputy }}:
                              {{
                              app.users.getOptionName(app.vehicleResponsible.model[
                              "vehicleResponsible.responsibles"
                              ][department.fields.bavVertreter2]
                              )}}
                            </small>
                          }
                        </div>
                      }
                      <!-- SECOND VERTRETER FIELDS ON CREATE/EDIT MODE -->
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <span
                          id="{{ department.fields.bavVertreter2 }}"
                          >
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.bavVertreter2"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                    </div>
                  </td>
                  <td class="p-1">
                    <div
                      class="col-md-12 text-center"
                      id="{{ department.fields.mawi }}"
                      >
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div>
                          {{
                          app.users.getOptionName( app.vehicleResponsible.model[
                          "vehicleResponsible.responsibles"
                          ][department.fields.mawi]
                          )}}
                        </div>
                      }
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <div>
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.mawi"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="false"
                            [largeInput]="true"
                          ></app-field>
                        </div>
                      }
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.mawiVertreter }}"
                          >
                          @if (display(department.fields.mawiVertreter)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.deputy }}:
                              {{
                              app.users.getOptionName(app.vehicleResponsible.model[
                              "vehicleResponsible.responsibles"
                              ][department.fields.mawiVertreter]
                              )}}
                            </small>
                          }
                        </div>
                      }
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <span
                          id="{{ department.fields.mawiVertreter }}"
                          >
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.mawiVertreter"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                      <!-- MAWI SECOND VERTRETER FIELDS / READ MODE-->
                      @if (app.isLocked(app.vehicleResponsible.id)) {
                        <div
                          class="text-muted font-weight-light font-italic"
                          id="{{ department.fields.mawiVertreter2 }}"
                          >
                          @if (display(department.fields.mawiVertreter2)) {
                            <small
                              class="text-muted font-weight-light font-italic"
                              >{{ app.text.impact.secondDeputy }}:
                              {{
                              app.users.getOptionName(app.vehicleResponsible.model[
                              "vehicleResponsible.responsibles"
                              ][department.fields.mawiVertreter2]
                              )}}
                            </small>
                          }
                        </div>
                      }
                      <!-- MAWI SECOND VERTRETER FIELDS ON CREATE/EDIT MODE -->
                      @if (!app.isLocked(app.vehicleResponsible.id)) {
                        <span
                          id="{{ department.fields.mawiVertreter2 }}"
                          >
                          <app-field
                    [model]="
                      app.vehicleResponsible.model[
                        'vehicleResponsible.responsibles'
                      ]
                    "
                            [field]="department.fields.mawiVertreter2"
                            [disabled]="app.isLocked(app.vehicleResponsible.id)"
                            [showLabel]="true"
                          ></app-field>
                        </span>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
    </div>
  </div>
}
